/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { BundleListSchema } from '../models/bundle-list-schema';
@Injectable({
  providedIn: 'root',
})
class BundlesService extends __BaseService {
  static readonly listBundlesWsPath = '/bundles';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * List all available bundles
   * @return Bundles retrieved successfully
   */
  listBundlesWsResponse(): __Observable<__StrictHttpResponse<BundleListSchema>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/bundles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BundleListSchema>;
      })
    );
  }
  /**
   * List all available bundles
   * @return Bundles retrieved successfully
   */
  listBundlesWs(): __Observable<BundleListSchema> {
    return this.listBundlesWsResponse().pipe(
      __map(_r => _r.body as BundleListSchema)
    );
  }
}

module BundlesService {
}

export { BundlesService }
